/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_Work_ExperienceInputs */

const en_resume_editor_work_experience = /** @type {(inputs: Resume_Editor_Work_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work Experience`)
};

const de_resume_editor_work_experience = /** @type {(inputs: Resume_Editor_Work_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berufserfahrung`)
};

const fr_resume_editor_work_experience = /** @type {(inputs: Resume_Editor_Work_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experience professionnelle`)
};

const es_resume_editor_work_experience = /** @type {(inputs: Resume_Editor_Work_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiencia laboral`)
};

const it_resume_editor_work_experience = /** @type {(inputs: Resume_Editor_Work_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esperienza lavorativa`)
};

const nl_resume_editor_work_experience = /** @type {(inputs: Resume_Editor_Work_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werkervaring`)
};

const pl_resume_editor_work_experience = /** @type {(inputs: Resume_Editor_Work_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doswiadczenie zawodowe`)
};

const fi_resume_editor_work_experience = /** @type {(inputs: Resume_Editor_Work_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Työkokemus`)
};

const da_resume_editor_work_experience = /** @type {(inputs: Resume_Editor_Work_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erhvervserfaring`)
};

const sv_resume_editor_work_experience = /** @type {(inputs: Resume_Editor_Work_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbetslivserfarenhet`)
};

/**
* | output |
* | --- |
* | "Work Experience" |
*
* @param {Resume_Editor_Work_ExperienceInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_work_experience = /** @type {((inputs?: Resume_Editor_Work_ExperienceInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_Work_ExperienceInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_work_experience(inputs)
	if (locale === "fr") return fr_resume_editor_work_experience(inputs)
	if (locale === "es") return es_resume_editor_work_experience(inputs)
	if (locale === "it") return it_resume_editor_work_experience(inputs)
	if (locale === "nl") return nl_resume_editor_work_experience(inputs)
	if (locale === "pl") return pl_resume_editor_work_experience(inputs)
	if (locale === "fi") return fi_resume_editor_work_experience(inputs)
	if (locale === "da") return da_resume_editor_work_experience(inputs)
	if (locale === "sv") return sv_resume_editor_work_experience(inputs)
	return en_resume_editor_work_experience(inputs)
});